import { useChat } from '../context/ChatContext';
import '../styles/LiveSupportButton.css';

function LiveSupportButton() {
  const { open, isOpen } = useChat();

  if (isOpen) return null;

  const logoUrl = `${process.env.PUBLIC_URL}/images/flarewhitelogo.png`;

  return (
    <button className="live-support-btn" onClick={open} aria-label="Open live support chat">
      <span className="live-support-btn__icon">
        <img src={logoUrl} alt="" className="live-support-btn__logo" />
        <span className="live-support-btn__dot" />
      </span>
      <span className="live-support-btn__label">Live Support</span>
    </button>
  );
}

export default LiveSupportButton;